import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { platformSelect } from '@bubble-ui/util-platform';
var BORDER_WIDTH = 1;
export var getDefaultStyleSheet = _ref => {
  var {
    avatarImageSize,
    backgroundColorToken,
    backgroundColorTokenArgs,
    borderColorToken,
    borderColorTokenArgs,
    cornerRadiusToken,
    designContext,
    disabled,
    imgResizeMode,
    large,
    medium,
    size,
    small,
    square,
    textColorToken,
    textColorTokenArgs
  } = _ref;
  var borderRadiusType = square ? 'square' : 'default';
  var sizeArg = size && size <= 32 ? 'small' : size && size > 32 && size <= 40 ? 'medium' : size && size > 40 && size < 56 ? 'default' : size && size >= 56 ? 'large' : large ? 'large' : medium ? 'medium' : small ? 'small' : 'default';
  var avatarBorderColor = borderColorToken ? designContext.get(borderColorToken, borderColorTokenArgs).toString() : designContext.get('avatar/border-color').withAlpha(0.1).toString();
  var avatarBorderRadius = designContext.get(cornerRadiusToken || 'avatar/corner-radius', {
    borderRadiusType
  }).value();
  var avatarBackgroundColor = backgroundColorToken ? designContext.get(backgroundColorToken, backgroundColorTokenArgs).toString() : designContext.get('avatar/background-color').toString();
  var avatarTextColor = textColorToken ? designContext.get(textColorToken, textColorTokenArgs).toString() : designContext.get('avatar/text-color').toString();
  var avatarTextStyle = designContext.get('avatar/text-style', {
    size: sizeArg
  }).styles();
  var avatarAmountBackgroundColor = designContext.get('avatar/amount-background-color').toString();
  var avatarAmountTextColor = designContext.get('avatar/amount-text-color').toString();
  var sizes = {
    width: avatarImageSize,
    minWidth: avatarImageSize,
    height: avatarImageSize
  };
  return {
    viewStyle: _objectSpread(_objectSpread({
      opacity: disabled ? 0.5 : 1
    }, sizes), {}, {
      borderRadius: avatarBorderRadius,
      backgroundColor: avatarBackgroundColor,
      textAlign: 'center',
      lineHeight: avatarImageSize,
      position: 'relative',
      overflow: 'hidden',
      alignItems: 'center',
      justifyContent: 'center'
    }),
    borderStyle: _objectSpread(_objectSpread({}, sizes), {}, {
      borderWidth: BORDER_WIDTH,
      borderColor: avatarBorderColor,
      borderStyle: 'solid',
      position: 'absolute',
      borderRadius: avatarBorderRadius
    }),
    iconViewStyle: {
      // not on native
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    textStyle: _objectSpread(_objectSpread({}, avatarTextStyle), {}, {
      color: avatarTextColor
    }),
    amountBackgroundStyle: _objectSpread(_objectSpread({}, sizes), {}, {
      backgroundColor: avatarAmountBackgroundColor,
      borderRadius: avatarBorderRadius,
      opacity: 0.7,
      position: 'absolute'
    }),
    amountTextStyle: _objectSpread(_objectSpread({}, avatarTextStyle), {}, {
      color: avatarAmountTextColor,
      position: 'absolute'
    }),
    hasSourceStyle: {
      // not used on native
      position: 'absolute',
      borderRadius: avatarBorderRadius,
      left: 0,
      top: 0
    },
    imgStyle: platformSelect({
      native: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        height: null,
        width: null
      },
      default: {
        objectFit: imgResizeMode
      }
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map